import { combineReducers } from 'redux';
import columns from './columns';
import order from './order';
import configs from './configs';

export default combineReducers({
  columns,
  order,
  configs
});
